import Button from "@/components/base/Button";
import { useSiteSettings } from "@/hooks/useSiteSettings";

const heroImage =
  "https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20diverse%20volunteers%20in%20red%20vests%20distributing%20food%20packages%20to%20families%20in%20a%20rural%20African%20village%20at%20golden%20hour%2C%20soft%20natural%20light%2C%20hopeful%20and%20generous%20atmosphere%2C%20premium%20humanitarian%20campaign%20photography%2C%20clean%20composition%2C%20high%20detail&width=1600&height=900&seq=humanity59-hero&orientation=landscape&nocache=true";

export default function Hero() {
  const { settings } = useSiteSettings();

  return (
    <section className="relative h-[520px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src={heroImage}
        alt="Membres d'Humanity59 distribuant des repas aux personnes dans le besoin"
        title="Solidarité — Humanity59"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 backdrop-blur px-4 py-1.5 text-xs md:text-sm font-medium text-background-50">
            <i className="ri-heart-3-fill text-primary-400"></i>
            Association humanitaire internationale
          </span>

          <h1 className="mt-6 font-heading text-4xl md:text-6xl font-bold text-background-50 leading-tight">
            {settings?.tagline || "Ensemble, faisons la différence."}
          </h1>

          <p className="mt-5 text-base md:text-lg text-background-50/90 max-w-2xl mx-auto leading-relaxed">
            {settings?.description ||
              "Humanity59 agit chaque jour pour soutenir les personnes en difficulté grâce à la solidarité de chacun."}
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button to="/contact" variant="primary" className="w-full sm:w-auto">
              <i className="ri-heart-3-line"></i>
              Faire un don
            </Button>
            <Button
              to="/actions"
              variant="outline"
              className="w-full sm:w-auto"
            >
              Découvrir nos actions
              <i className="ri-arrow-right-line"></i>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}